import { ExternalDriverResponseDto } from '@planning/app/api'
import externalDriverService from '@planning/services/externalDriverService'
import { debounce } from 'lodash'
import { action, makeObservable, observable, runInAction } from 'mobx'

export class DriverAutoCompleteStore {
  options: ExternalDriverResponseDto[] = []
  isFiltertingByName = true
  isLoading = false

  constructor() {
    makeObservable(this, {
      options: observable,
      isFiltertingByName: observable,
      isLoading: observable,

      setLoading: action,
      filterOptions: action,
      setOptions: action,
      setFilteringByName: action,
    })
  }

  setLoading = (isLoading: boolean) => {
    this.isLoading = isLoading
  }

  setOptions = (options: ExternalDriverResponseDto[]) => {
    runInAction(() => {
      this.options = options
    })
  }

  setFilteringByName = (isFiltertingByName: boolean) => {
    this.isFiltertingByName = isFiltertingByName
  }

  filterOptions = debounce(async (filter?: string) => {
    if (!filter || filter.trim() === '') {
      this.setOptions([])
      this.setLoading(false)
      return
    }

    const data = await externalDriverService.getByPartialNameOrId(filter, this.isFiltertingByName)
    const options = [
      ...data,
      {
        id: 0,
        name: '',
        banned: false,
        driverID: '0',
      },
    ]
    this.setOptions(options)
    this.setLoading(false)
  }, 500)
}
